export default __webpack_public_path__ + "static/media/img-video-2.a59854e1.png";